/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 * NOTE: The extract-intl build script (internals/scripts/extract-intl.js) still
 * uses CommonJS require() directly — it does NOT go through this file.
 */
import { addLocaleData } from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'

import enTranslationMessages from './translations/en.json'

addLocaleData(enLocaleData)

export const DEFAULT_LOCALE = 'en'

// prettier-ignore
const appLocales = [
  'en',
]

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {}
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key]
    return Object.assign(formattedMessages, { [key]: formattedMessage })
  }
  return Object.keys(messages).reduce(flattenFormattedMessages, {})
}

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
}

export { appLocales, formatTranslationMessages }
